<template>
	<system v-if="isOpen" class="system system--info">
		<div class="system__container system__container--bar">
			<ElementStatusled v-if="hasWifi" name="wifi" content="WiFi" :message-type="wifiLed" />
			<ElementStatusled v-if="hasBeacons" name="beacons" content="Beacons" :message-type="bluetoothLed" />
			<ElementStatusled v-if="hasMqtt" name="mqtt" content="MQTT" :message-type="mqttLed" />
			<ElementButton v-if="!isLoaner" name="close" @click="close" />
		</div>
		<div class="system__container system__container--content">
			<ElementHeadlineBig content="Device Info" />

			<ElementText name="device" :content="`Device: ${deviceName}`" />
			<ElementText name="wc" :content="`WC: ${wcVersion}`" />
			<ElementText name="app" :content="`App: ${appVersion}`" />

			<ElementList :entries="items" />
		</div>

		<ElementStatusled name="big" :content="batteryStatus" :message-type="batteryStateLed" />
	</system>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { appExit } from '@/tools/nativeInterfaceFunctions';
import UiBase from '../ui/base.vue';
import { mutationTypes } from '@/types';
import { uiComponents, uiStates } from '@/tools/viewState';
import { meaning, BATTERY_STATE } from '@/tools/consts';

export default {
	extends: UiBase,
	data() {
		return {
			name: uiComponents.systemInformation,
			items: [
				{
					name: 'start',
					title: 'start',
					url: '',
					click: event => {
						this.doStart(event);
					},
				},
				{
					name: 'update',
					title: 'update',
					url: '',
					click: event => {
						this.doUpdate(event);
					},
				},
				// {
				// 	name: 'sendlog',
				// 	content: 'send log',
				// 	click: event => {
				// 		this.doSendLog(event);
				// 	},
				// },
			],
		};
	},
	computed: {
		...mapState(['viewState', 'isLoaner']),
		...mapState({
			deviceName: state => state.systemInfo.deviceName,
			appVersion: state => state.systemInfo.appVersion,
			batteryState: state => state.systemInfo.batteryState,
			bluetoothIsActive: state => state.bluetooth.isActive,
			beaconsDetected: state => Object.keys(state.bluetooth.detectedBeacons).length > 0,
			batteryStatus: state => state.systemInfo.batteryState,
			wcVersion: state => state.systemInfo.wcVersion,
			hasMqtt: state => (state.dataSourceCFG ? state.dataSourceCFG.global.MQTTSupport.mobile.active : false),
			hasBeacons: state =>
				state.dataSourceCFG ? state.dataSourceCFG.global.beaconSettings.activateBluetooth : false,
			hasWifi: () => false,
		}),
		bluetoothLed() {
			if (this.bluetoothIsActive) {
				if (this.beaconsDetected) {
					return meaning.ok;
				} else return meaning.error;
			}
			return meaning.unkown;
		},
		wifiLed() {
			return meaning.unkown;
		},
		mqttLed() {
			return meaning.unkown;
		},
		batteryStateLed() {
			switch (this.batteryStatus) {
				case BATTERY_STATE.unkown:
					return meaning.unkown;
				case BATTERY_STATE.DISCHARGING:
					return meaning.error;
				case BATTERY_STATE.CHARGING:
					return meaning.warning;
				case BATTERY_STATE.FULL:
					return meaning.info;
			}
		},
	},
	methods: {
		...mapActions(['loanerStart']),
		...mapMutations([mutationTypes.viewStateSetUiState]),
		doStart() {
			this.loanerStart();
			this.viewStateSetUiState({ id: uiComponents.uiMap, uiState: uiStates.hidden });

			this.close();
		},
		doUpdate() {
			appExit(true);
		},
		doSendLog() {},
	},
};
</script>
